import dayjs from "dayjs";

/** 篩選列的期間快捷用的日期區間（含頭含尾，YYYY-MM-DD） */

export const thisMonth = (): [string, string] => [
  dayjs().startOf("month").format("YYYY-MM-DD"),
  dayjs().endOf("month").format("YYYY-MM-DD"),
];

export const thisYear = (): [string, string] => [
  dayjs().startOf("year").format("YYYY-MM-DD"),
  dayjs().endOf("year").format("YYYY-MM-DD"),
];

export const lastNMonths = (n: number): [string, string] => [
  dayjs()
    .subtract(n - 1, "month")
    .startOf("month")
    .format("YYYY-MM-DD"),
  dayjs().endOf("month").format("YYYY-MM-DD"),
];
